import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * PublicFooter - Footer component for Public Experience Mode (unauthenticated demo pages)
 * Used on: Public Library, Demo Player
 */
const PublicFooter = () => {
  const location = useLocation();

  return (
    <footer className="bg-slate-900 text-slate-300 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-12">
          {/* Logo and Simple Link List */}
          <div className="flex flex-col items-center text-center space-y-6">
            <img 
              src="/newaudia-logo.jpg" 
              alt="NewAudia™" 
              className="h-16 w-auto rounded-lg"
            />
            
            {/* Simple Footer Navigation - Public Experience Only */}
            <nav className="flex flex-wrap justify-center gap-6 text-sm">
              {[
                { label: 'Welcome', path: '/' },
                { label: 'Public Library', path: '/public/library' },
                { label: 'About', path: '/about' },
                { label: 'Pricing', path: '/pricing' },
                { label: 'FAQ', path: '/faq' },
                { label: 'Contact', path: '/contact' },
                { label: 'Sign In', path: '/login' }
              ]
                .filter(item => location.pathname !== item.path) // Hide current page
                .map((item) => (
                  <Link 
                    key={item.path}
                    to={item.path} 
                    className="text-slate-400 hover:text-slate-100 transition-colors"
                  >
                    {item.label}
                  </Link>
                ))
              }
            </nav>
            
            <p className="text-sm text-slate-400 leading-relaxed max-w-xl">
              Explore NFD-SmartBook™ experiences. Listen, learn, and engage with stories like never before.
            </p>
          </div>
        </div>

        {/* Powered by Emergent */}
        <div className="border-t border-slate-800 py-8">
          <div className="flex justify-center">
            <a 
              href="https://app.emergent.sh/register?ref=rdbr654428"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block group"
            >
              <img 
                src="/emergent-logo.png" 
                alt="Emergent.sh" 
                className="h-auto w-[200px] mx-auto mb-2 transition-transform group-hover:scale-105"
              />
              <p className="text-sm font-semibold text-slate-300 group-hover:text-purple-400 transition-colors text-center">
                Powered By Emergent.sh
              </p>
              <p className="text-xs text-slate-400 group-hover:text-purple-300 transition-colors text-center">
                Build Your Tomorrow Today!
              </p>
            </a>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-slate-800 py-6">
          <div className="flex flex-col items-center text-center space-y-2">
            <p className="text-sm text-slate-400">
              Copyright © 2026 NewAudia<sup className="font-bold text-[0.6em]">TM</sup> Systems, LLC
            </p>
            <a 
              href="https://www.newaudia.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-indigo-400 hover:text-indigo-300 transition-colors"
            >
              www.NewAudia.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
